import React, { useState } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import MuiListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";
import { ThemeProvider } from "@material-ui/styles";
import { createMuiTheme } from "@material-ui/core";
import moment from "moment";

import { DATE_TIME_FORMAT, SHORT_DATE_FORMAT } from "../../../../constants";

const useStyles = makeStyles((theme) => ({
   selected: {
      "& $primary, & $secondary": {
         color: theme.palette.common.white,
      },
   },
   primary: {},
   secondary: {},
}));

export default function SelectedListItem(props) {
   const {
      handlerInputChange,
      items,
      question,
      jobDuration,
      productType,
      loadingAvailability,
      theme,
      LANGUAGE_TEXT,
      accountState,
   } = props;
   const [selectedIndex, setSelectedIndex] = useState();

   const materialTheme = createMuiTheme({
      overrides: {
         MuiListItemText: {
            multiline: {
               marginTop: 0,
               marginBottom: 0,
            },
         },
         MuiTypography: {
            body1: {
               color: theme.textColorPrimary,
               fontSize: 16,
               fontFamily: "Avenir, sans-serif",
               fontWeight: 900,
               lineHeight: "39px",
               letterSpacing: 0,
            },
            body2: {
               fontSize: 14,
               fontFamily: "Avenir, sans-serif",
               fontWeight: 300,
               lineHeight: "39px",
               letterSpacing: 0,
            },
            colorTextSecondary: {
               color: theme.textColorPrimary,
            },
            h6: {
               color: theme.textColorPrimary,
               fontSize: 16,
               fontFamily: "Avenir, sans-serif",
               fontWeight: 900,
               lineHeight: "22px",
               letterSpacing: 0,
            },
         },
      },
   });

   const classes = useStyles();

   const ListItem = withStyles({
      root: {
         border: `${theme.shadowColor} solid 1px`,
         borderRadius: 3,

         "&:not(:last-child)": {
            marginBottom: 8,
         },
         "&$selected": {
            backgroundColor: theme.primaryColor,
            borderColor: theme.primaryColor,
         },
         "&$selected:hover": {
            backgroundColor: theme.primaryColor,
            borderColor: theme.primaryColor,
            color: theme.lighterColor,
         },
         "&:hover": {
            backgroundColor: theme.lighterColor,
            borderColor: theme.shadowColor,
         },
      },
      selected: {},
   })(MuiListItem);

   const handleListItemClick = (
      index,
      startDate,
      endDate,
      availableResources
   ) => {
      setSelectedIndex(index);
      const params = {
         jobType: productType,
         startDate,
         endDate,
         id: question.id,
         duration: jobDuration,
         availableResources,
      };
      handlerInputChange(params);
   };

   return (
      <div>
         <ThemeProvider theme={materialTheme}>
            <Typography variant="h6" gutterBottom style={{ marginTop: "8px" }}>
               {accountState?.conditionSpecificBehaviors?.translateText &&
               accountState?.storeInfo?.languageCode
                  ? LANGUAGE_TEXT[accountState?.storeInfo?.languageCode]
                       ?.available_times
                  : "Available Times"}
            </Typography>
            {!loadingAvailability && (
               <List component="nav" aria-label="time list">
                  {items.map((item, index) => {
                     return (
                        <ListItem
                           key={`${ListItem}-${index}`}
                           button
                           selected={selectedIndex === index}
                           onClick={() =>
                              handleListItemClick(
                                 index,
                                 item.start,
                                 item.end,
                                 item.availableResources
                              )
                           }
                           classes={{
                              selected: classes.selected,
                           }}
                        >
                           <ListItemText
                              primary={`${moment
                                 .parseZone(accountState?.skeduloInfo?.customTimeSlots?.isEnable ? item.customStart : item.start)
                                 .format(DATE_TIME_FORMAT)} - ${moment
                                 .parseZone(accountState?.skeduloInfo?.customTimeSlots?.isEnable ? item.customEnd : item.end)
                                 .format(DATE_TIME_FORMAT)}`}
                              secondary={moment
                                 .parseZone(accountState?.skeduloInfo?.customTimeSlots?.isEnable ? item.customStart : item.start)
                                 .format(SHORT_DATE_FORMAT)}
                              classes={{
                                 primary: classes.primary,
                                 secondary: classes.secondary,
                              }}
                           />
                        </ListItem>
                     );
                  })}
               </List>
            )}
         </ThemeProvider>
      </div>
   );
}
